import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import { infoFormatterIntl, userFIOFormatter } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function FIOView(props) {
  const {
    fieldsValidation = {},
    procedure,
    applicantType,
    currentApplication = {},
  } = props;

  const applicant_new = currentApplication?.applicant_new || {};
  const files = currentApplication?.files || [];
  const registry_subject = currentApplication?.registry_subject || {};

  const {
    last_name,
    first_name,
    middle_name,
  } = applicant_new;

  const fio_change_document = files.find(item => item.collection_name === 'fio_change_document');

  const hasFIOData = !!(
    last_name
            || first_name
            || middle_name
  ) || last_name === null
        || first_name === null
        || middle_name === null;

  const isValidProcedure = [PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure);
  const isValidApplicantType = [USER_TYPE.PRIVATE_PERSON_OLD, USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType);

  if (!isValidProcedure || !isValidApplicantType) {
    return null;
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasFIOData,
            }}
            label="Изменилось ФИО"
          />
        </Col>
      </Row>
      {hasFIOData && (
        <>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'old.fio',
              userFIOFormatter(registry_subject),
              fieldsValidation,
              'full_name',
            )}
          </Row>
          <Row className="row-cols-3">
            {infoFormatterIntl(
              'new.last_name',
              last_name,
              fieldsValidation,
              'applicant_new.last_name',
            )}
            {infoFormatterIntl(
              'new.first_name',
              first_name,
              fieldsValidation,
              'applicant_new.first_name',
            )}
            {infoFormatterIntl(
              'new.middle_name',
              middle_name,
              fieldsValidation,
              'applicant_new.middle_name',
            )}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'media.fio_change_document',
              fio_change_document ? (
                <FileView
                  readOnly
                  withoutMime
                  withoutHr
                  files={[fio_change_document]}
                />
              ) : null,
              fieldsValidation,
              '',
              6,
            )}
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
